module.exports = __webpack_public_path__ + "css/Powercore.49c7b049.css";